import React from "react";

import "../tailwind.css";

export function Root({ children }: { children: React.ReactNode }) {
  return <div>{children}</div>;
}
